import * as React from "react"

const NormalContentPara = ({ blok, len }) => (
  <p className="mt-2 text-lg text-gray-500">{blok.paragraph}</p>
)

export default NormalContentPara
